<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="dimensions"
    :height="dimensions"
    viewBox="0 0 240 240"
  >
    <defs>
      <linearGradient id="4bwjz0oq0b" x1="100%" x2="0%" y1="100%" y2="-9.901%">
        <stop offset="0%" />
        <stop offset="100%" stop-color="#FFF" />
      </linearGradient>
      <linearGradient id="p5tec6rwle" x1="73.781%" x2="26.219%" y1="100%" y2="-9.901%">
        <stop offset="0%" />
        <stop offset="100%" stop-color="#FFF" />
      </linearGradient>
      <filter id="zqo911vjzc" width="106.2%" height="106.2%" x="-3.1%" y="-3.1%" filterUnits="objectBoundingBox">
        <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="5" />
        <feOffset dx="5" dy="5" in="shadowBlurInner1" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          in="shadowInnerInner1"
          result="shadowMatrixInner1"
          values="0 0 0 0 0.650980392 0 0 0 0 0.670588235 0 0 0 0 0.741176471 0 0 0 1 0"
        />
        <feGaussianBlur in="SourceAlpha" result="shadowBlurInner2" stdDeviation="5" />
        <feOffset dx="-5" dy="-5" in="shadowBlurInner2" result="shadowOffsetInner2" />
        <feComposite
          in="shadowOffsetInner2"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner2"
        />
        <feColorMatrix
          in="shadowInnerInner2"
          result="shadowMatrixInner2"
          values="0 0 0 0 0.980392157 0 0 0 0 0.984313725 0 0 0 0 1 0 0 0 1 0"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixInner1" />
          <feMergeNode in="shadowMatrixInner2" />
        </feMerge>
      </filter>
      <filter id="pljthrqasf" width="115.6%" height="110.8%" x="-7.8%" y="-5.4%" filterUnits="objectBoundingBox">
        <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="5" />
        <feOffset dx="5" dy="5" in="shadowBlurInner1" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          in="shadowInnerInner1"
          result="shadowMatrixInner1"
          values="0 0 0 0 0.650980392 0 0 0 0 0.670588235 0 0 0 0 0.741176471 0 0 0 1 0"
        />
        <feGaussianBlur in="SourceAlpha" result="shadowBlurInner2" stdDeviation="5" />
        <feOffset dx="-5" dy="-5" in="shadowBlurInner2" result="shadowOffsetInner2" />
        <feComposite
          in="shadowOffsetInner2"
          in2="SourceAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
          result="shadowInnerInner2"
        />
        <feColorMatrix
          in="shadowInnerInner2"
          result="shadowMatrixInner2"
          values="0 0 0 0 0.980392157 0 0 0 0 0.984313725 0 0 0 0 1 0 0 0 1 0"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixInner1" />
          <feMergeNode in="shadowMatrixInner2" />
        </feMerge>
      </filter>
      <rect id="optfuchaza" width="240" height="240" x="0" y="0" rx="120" />
      <path
        id="649xcbgj1d"
        d="M48.254 36.632C75.683 36.632 96 59.315 96 87.635v.281c0 28.32-20.571 51.284-48 51.284l.254-24.656c13.587 0 22.603-12.117 22.603-26.347v-.28c0-14.231-9.269-26.63-22.857-26.63l.254-24.655zM48 0l-.254 24.656c-13.46 0-22.476 12.117-22.476 26.346v.282c0 14.23 9.27 26.629 22.73 26.629l-.254 24.655C20.318 102.568 0 79.885 0 51.565v-.281C0 22.964 20.571 0 48 0z"
      />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g>
            <g transform="translate(-262 -414) translate(222 106) translate(40 308)">
              <use fill="#EBECF0" xlink:href="#optfuchaza" />
              <use
                fill="url(#4bwjz0oq0b)"
                fill-opacity=".4"
                style="mix-blend-mode:soft-light"
                xlink:href="#optfuchaza"
              />
              <use fill="#000" filter="url(#zqo911vjzc)" xlink:href="#optfuchaza" />
              <rect
                width="238"
                height="238"
                x="1"
                y="1"
                stroke="#FFF"
                stroke-linejoin="square"
                stroke-opacity=".4"
                stroke-width="2"
                rx="119"
              />
            </g>
            <g>
              <g transform="translate(-262 -414) translate(222 106) translate(40 308) translate(72 50.5)">
                <use fill="#EBECF0" xlink:href="#649xcbgj1d" />
                <use
                  fill="url(#p5tec6rwle)"
                  fill-opacity=".4"
                  style="mix-blend-mode:soft-light"
                  xlink:href="#649xcbgj1d"
                />
                <use fill="#000" filter="url(#pljthrqasf)" xlink:href="#649xcbgj1d" />
                <path
                  stroke="#FFF"
                  stroke-linejoin="square"
                  stroke-opacity=".4"
                  stroke-width="2"
                  d="M49.244 37.642c12.89.263 24.117 5.664 32.22 14.32C89.943 61.017 95 73.626 95 87.635c0 14.137-5.113 26.875-13.638 36.034-8.162 8.768-19.452 14.248-32.352 14.52h0l.234-22.665c6.486-.272 11.923-3.213 15.846-7.785 4.293-5.005 6.767-11.981 6.767-19.542 0-7.686-2.528-14.791-6.867-19.899-3.981-4.687-9.482-7.705-15.98-7.989h0zM46.99 1.01l-.234 22.666c-6.432.274-11.842 3.22-15.749 7.8-4.268 5.002-6.737 11.972-6.737 19.525 0 7.678 2.523 14.777 6.836 19.884 3.966 4.695 9.44 7.718 15.884 8.004h0l-.234 22.668c-12.89-.263-24.117-5.664-32.22-14.32C6.058 78.182 1 65.573 1 51.564 1 37.428 6.113 24.69 14.638 15.531 22.8 6.763 34.09 1.283 46.99 1.011h0z"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'medium'
    }
  },
  computed: {
    dimensions() {
      switch (this.size) {
        case 'medium':
        default:
          return '76px';
      }
    }
  }
};
</script>
